import React, { useEffect } from "react";
import { View, StyleSheet } from "react-native";
import Text from "./text";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import useToast from "libs/hooks/useToast";
import { SCREEN_WIDTH, TABLET_PC } from "../libs/utils/constants";
import { useSpring, animated } from "react-spring";
import { getButtonModalWidth } from "../libs/utils/dimensions";

const AnimatedView = animated(View);

const Toast = () => {
  const [showToast, message, type] = useToast();
  const insets = useSafeAreaInsets();
  const [springs, api] = useSpring(() => ({
    from: { bottom: -84 },
  }));

  useEffect(() => {
    if (showToast) {
      api.start({
        to: {
          bottom: insets.bottom + 84,
        },
      });
    } else {
      api.start({
        to: {
          bottom: -84,
        },
      });
    }
  }, [showToast]);
  return (
    <AnimatedView
      style={{
        ...styles.container,
        ...(type === "success" && styles.success),
        ...springs,
      }}
    >
      <Text numberOfLines={2}>{message}</Text>
    </AnimatedView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: "#ed4337f1",
    position: "absolute",
    left: !TABLET_PC ? 36 : undefined,
    right: !TABLET_PC ? 36 : undefined,
    justifyContent: "center",
    padding: 15,
    borderRadius: 5,
    width: TABLET_PC ? getButtonModalWidth() : undefined,
    alignSelf: TABLET_PC ? "center" : undefined,
  },
  success: {
    backgroundColor: "#33d9b2",
  },
});

export default Toast;
